import React from "react";
import CFAQ from "./Cfaq";
import {
    AppLayout,
    Header,
    SideNavigation,
    Container,
    ContentLayout,
    Cards,
    Box,
    Link,
    SpaceBetween,
    BreadcrumbGroup
} from '@cloudscape-design/components';
import SFAQ from "./Sfaq";
import { NavigationSide } from "./Navigation";

function Narrative() {
    return (
        <AppLayout
          navigation={<NavigationSide />}
          content={<MainContent />}
          header={<PageHeader />}
          contentType="dashboard"
        />
    );
  }
  function Navigation() {
    return (
      <SideNavigation
        header={{ text: 'AWS Eloquence', href: '/' }}
        items={[
          { type: 'link', text: 'Learn More', href: '/learnmore' },
          { type: 'link', text: 'Get Started', href: '/getstarted' },
          { type: 'link', text: 'My Meetings', href: '/meetings'},
          { type: 'link', text: 'Meet the Team', href: '/meettheteam'},
          { type: 'link', text: 'Architecture Diagram', href: '/architecture'},
          { type: 'divider' },
          { type: 'link', text: 'Documentation', href: '/documentation' },
        ]}
      />
    );
  }
  
  function MainContent() {
      //const navigate = useNavigate();
      return (
        <>
        <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Documentation", href: "/documentation" },
          { text: "Narrative", href: "/narrative" }
        ]}
        ariaLabel="Breadcrumbs"
      />
      <br></br>
        <ContentLayout
          defaultPadding  
          // headerBackgroundStyle="linear-gradient(135deg, rgb(71, 17, 118) 3%, rgb(131, 57, 157) 44%, rgb(149, 85, 182) 69%, rgb(145, 134, 215) 94%)"
          headerVariant="high-contrast"
          maxContentWidth={2000}
          disableOverlap
          header={
          <SpaceBetween size="m">
            <Header variant="h1" description="Read our Narrative">AWS Eloquence Narrative</Header>
          </SpaceBetween>
          }
        >
          <br></br>
          <SpaceBetween size="s">
          <Container>
            <h3>Purpose</h3>
                <p>AWS Eloquence is a new AI-powered presentation coach tool developed by Amazon Web Services (AWS) to help Solution Architects improve their customer conversation skills. The 5 purpose of this document is to highlight how this tool will empower AWS Solution 6 Architects to deliver more effective and impactful customer experiences.</p>
          </Container>
          <Container>
            <h3>Problem/Opportunity</h3>
                <p>As a leading cloud service provider, AWS has built a strong reputation for technical expertise and customer-centric solutions. Delivering effective customer-facing presentations is a critical part of the Solution Architect role. 
                    They must clearly explain complex technical concepts, recommend the appropriate AWS services, and address customer concerns in a confident manner to gain the customer’s trust. However, Solution Architects have historically faced challenges in getting consistent, actionable feedback to improve their speaking skills and messaging. 
                    Feedback from peers or managers can be subjective and sporadic, making it difficult for Solution Architects to truly understand their strengths, weaknesses, and opportunities for growth. This lack of structured guidance limits the growth of Solution Architects’ customer conversation skills over time. 
                    Solution Architects at every level have to prepare for AWSome Builder, a program involving three simulated customer interactions. Many Solution Architects face significant challenges while preparing for these conversations because the current feedback process is fragmented and inconsistent. Solution Architects’ feedback comes from multiple mentors during practice sessions, which can lead to conflicting feedback across mentors. 
                    This disjointed approach often results in conflicting advice, complicating preparation and increasing stress for Solution Architects. Additionally, the subjective nature of customer conversations makes it challenging for Solution Architects to objectively benchmark their performance. Feedback from peers or managers may vary based on personal biases, experiences, and communication styles. 
                    This lack of a standardized evaluation framework prevents Solution Architects from developing a clear understanding of their progress over time. In a recent survey, 87% of Solution Architects reported that they would benefit from having a conversation coach that provides consistent feedback and documents their progress over time. To address these challenges, AWS recognized the need for an automated, data-driven solution that could provide Solution Architects with structured, actionable feedback on their customer-facing interactions. 
                    communication skills, AWS aimed to enhance the overall customer experience and drive stronger brand loyalty. By empowering Solution Architects to refine their communication skills, AWS aimed to enhance the overall customer experience and drive stronger brand loyalty.
                </p>
            </Container>
          <Container>
            <h3>Recommendation</h3>
                <p>
                AWS is launching AWS Eloquence, an AI-powered presentation coach that Solution Architects can leverage to receive real-time feedback on their customer-facing interactions. AWS Eloquence is designed to be integrated with Amazon Chime, the company's video conferencing and collaboration platform, allowing Solution Architects to easily invite the agent to their customer meetings. During the conversation, AWS Eloquence will use advanced natural language processing and sentiment analysis to evaluate factors such as: 
                    <ul>
                        <li>Speaking rate and cadence </li>
                        <li>Usage of filler words and hesitations </li>
                        <li>Adoption of key AWS terminology and messaging</li> 
                        <li>Overall flow and coherence of the conversation </li>
                        <li>Ability to address customer questions and concerns</li>
                    </ul> 
                After the meeting, the Solution Architect can access a detailed dashboard that provides a performance score, as well as specific, actionable feedback on areas for improvement. This includes suggestions for reducing filler words, improving speaking pace, and more effectively incorporating AWS-specific language and concepts. 
                AWS Eloquence is trained on successful customer conversations from AWS's AWSome Builder program, which prepares new Solution Architects for field work. This allows the tool to provide tailored guidance that aligns with the company's best practices and customer engagement strategies. 
                By empowering Solution Architects with this automated, data-driven feedback, AWS aims to help them refine their presentation skills, build confidence, and ultimately deliver more engaging and effective customer experiences. 
                </p>
          </Container>
          <Container>
            <h3>Next Steps</h3>
                <p>
                AWS will roll out the first iteration of AWS Eloquence in Q4 of 2024 to a small group of TechU resident Solution Architects in Austin, TX for testing purposes. 
                This will enable them to seamlessly integrate the tool into their customer-facing activities as they continue to develop and learn during residency. The Eloquence team will be gathering frequent feedback on the effectiveness of the tool and leverage that data to iterate the design and roll out a version 2 by end of Q2 2025. 
                By empowering Solution Architects with automated, personalized feedback, AWS aims to drive measurable enhancements in customer satisfaction (CSAT) scores and a reduction in  escalation rates. This will strengthen customer trust, increase brand loyalty, and create new opportunities for cross-selling and upselling AWS services.
                </p>
          </Container>
            
          <Container><CFAQ></CFAQ></Container>
            
          <Container><SFAQ></SFAQ></Container>

          </SpaceBetween>
      </ContentLayout>
      </>
    );
  }
  function PageHeader() {
    return (
      <Header
        variant="h1"
        actions={
          <div>
            
          </div>
        }
      >
        My Application
      </Header>
    );
  }
  export default Narrative;

